import { useState, useEffect } from "react";
import { createWorker } from "../functions/WorkersQueries";

const NuevoTrabajador = ({ setNuevoTrabajador, setRefrescar }) => {
	const [data, setData] = useState({
		nombre: "",
		username: "",
		curp: "",
		password: "",
		permiso_altas: "",
		permiso_bajas: "",
		permiso_modificaciones: "",
		boton_retencion_con_intereses: "",
		boton_retencion_sin_intereses: "",
	});
	const submitForm = (e) => {
		e.preventDefault();
		createWorker(data);
		setNuevoTrabajador(0);
		setRefrescar(1);
	};

	const updateField = (e) => {
		setData({ ...data, [e.target.name]: e.target.value });
	};

	// Disable ignore enter
	useEffect(() => {
		const listener = (event) => {
			if (event.code === "Enter" || event.code === "NumpadEnter") {
				alert(
					"Asegúrese de llenar los datos marcados con asterisco y después de click en el botón Guardar"
				);
				event.preventDefault();
			}
		};
		document.addEventListener("keydown", listener);
		return () => {
			document.removeEventListener("keydown", listener);
		};
	}, []);

	return (
		<>
			<div className="text-center text-xl font-semibold text-sky-700 mt-6">
				Nuevo Trabajador:
			</div>

			<form method="POST" onSubmit={submitForm}>
				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Nombre *</span>
					</div>
					<input
						type="text"
						name="nombre"
						id="nombre"
						onChange={updateField}
						required
						className="mr-3 p-1 border border-slate-400 rounded w-3/4"
					/>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Nombre de usuario *</span>
					</div>
					<input
						type="text"
						name="username"
						id="username"
						onChange={updateField}
						required
						className="mr-3 p-1 border border-slate-400 rounded w-3/4"
					/>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>CURP *</span>
					</div>
					<input
						type="text"
						name="curp"
						id="curp"
						onChange={updateField}
						required
						minLength="18"
						maxLength="18"
						className="mr-3 p-1 border border-slate-400 rounded w-3/4"
					/>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Contraseña *</span>
					</div>
					<input
						type="password"
						name="password"
						id="password"
						onChange={updateField}
						required
						className="mr-3 p-1 border border-slate-400 rounded w-3/4"
					/>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Permiso de altas *</span>
					</div>
					<div className="mr-3 p-1 w-3/4">
						<input
							onChange={updateField}
							required
							type="radio"
							name="permiso_altas"
							className="ml-6 border-2 cursor-pointer"
							value="1"
						/>{" "}
						Si
						<input
							onChange={updateField}
							required
							type="radio"
							name="permiso_altas"
							className="ml-6 border-2 cursor-pointer"
							value="0"
						/>{" "}
						No
					</div>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Permiso de bajas *</span>
					</div>
					<div className="mr-3 p-1 w-3/4">
						<input
							onChange={updateField}
							required
							type="radio"
							name="permiso_bajas"
							className="ml-6 border-2 cursor-pointer"
							value="1"
						/>{" "}
						Si
						<input
							onChange={updateField}
							required
							type="radio"
							name="permiso_bajas"
							className="ml-6 border-2 cursor-pointer"
							value="0"
						/>{" "}
						No
					</div>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Permiso de modificaciones *</span>
					</div>
					<div className="mr-3 p-1 w-3/4">
						<input
							onChange={updateField}
							required
							type="radio"
							name="permiso_modificaciones"
							className="ml-6 border-2 cursor-pointer"
							value="1"
						/>{" "}
						Si
						<input
							onChange={updateField}
							required
							type="radio"
							name="permiso_modificaciones"
							className="ml-6 border-2 cursor-pointer"
							value="0"
						/>{" "}
						No
					</div>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Retención con intereses *</span>
					</div>
					<div className="mr-3 p-1 w-3/4">
						<input
							onChange={updateField}
							required
							type="radio"
							name="boton_retencion_con_intereses"
							className="ml-6 border-2 cursor-pointer"
							value="1"
						/>{" "}
						Si
						<input
							onChange={updateField}
							required
							type="radio"
							name="boton_retencion_con_intereses"
							className="ml-6 border-2 cursor-pointer"
							value="0"
						/>{" "}
						No
					</div>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>Retención sin intereses *</span>
					</div>
					<div className="mr-3 p-1 w-3/4">
						<input
							onChange={updateField}
							required
							type="radio"
							name="boton_retencion_sin_intereses"
							className="ml-6 border-2 cursor-pointer"
							value="1"
						/>{" "}
						Si
						<input
							onChange={updateField}
							required
							type="radio"
							name="boton_retencion_sin_intereses"
							className="ml-6 border-2 cursor-pointer"
							value="0"
						/>{" "}
						No
					</div>
				</div>

				<div className="flex flex-row items-center max-w-full my-2">
					<div className="mx-9 text-center w-1/4">
						<span>INE *</span>
					</div>
					<div className="mr-3 p-1 w-3/4">
						<input
							onChange={updateField}
							required
							type="radio"
							name="boton_retencion_sin_intereses"
							className="ml-6 border-2 cursor-pointer"
							value="1"
						/>{" "}
						Si
						<input
							onChange={updateField}
							required
							type="radio"
							name="boton_retencion_sin_intereses"
							className="ml-6 border-2 cursor-pointer"
							value="0"
						/>{" "}
						No
					</div>
				</div>

				<div className="flex flex-row items-center justify-center mt-4 mb-16">
					<button
						className="mx-4 bg-gray-500 text-white rounded-xl py-1 px-3 hover:bg-slate-400 hover:text-black hover:duration-500"
						onClick={() => setNuevoTrabajador(0)}
					>
						Cancelar
					</button>
					<button
						className="mx-4 bg-gray-500 text-white rounded-xl py-1 px-3 hover:bg-slate-400 hover:text-black hover:duration-500"
						type="submit"
						onKeyPress={submitForm}
					>
						Guardar
					</button>
				</div>
			</form>
		</>
	);
};

export default NuevoTrabajador;
